import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Ambulance, Radio, Tent, ShieldPlus } from 'lucide-react';
import { SERVICES } from '../mock/mock';

const OFFERINGS = [
  { icon: ShieldPlus, text: 'Skilled event medics trained in trauma & pre-hospital care' },
  { icon: Ambulance, text: '4x4 response vehicles & treatment tents' },
  { icon: Radio, text: 'Advanced pain relief, airway support & IV therapy' },
  { icon: Tent, text: 'Customisable coverage matched to your event size & risk' },
];

const Services = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div>
      <div className="relative bg-[#141414] text-white py-20 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1722974180453-305758503804?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#141414] to-[#141414]/60" />
        <div className="container-fes relative">
          <span className="section-label">Our Services</span>
          <h1 className="font-head text-4xl md:text-5xl uppercase mt-2 max-w-2xl">Professional Medical Coverage, Anywhere</h1>
          <p className="text-gray-300 mt-4 max-w-2xl text-lg">Reliable medical support for events, worksites and remote environments. Our teams arrive fully equipped and ready to respond.</p>
        </div>
      </div>

      <section className="py-16 md:py-20 bg-white">
        <div className="container-fes">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => (
              <div key={s.id} className="group bg-white rounded-lg overflow-hidden border border-gray-100 hover-lift flex flex-col">
                <div className="aspect-video overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-head text-xl uppercase text-[#141414] mb-2">{s.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed flex-1">{s.desc}</p>
                  <Link to="/contact" className="inline-flex items-center gap-1 mt-4 font-cond uppercase font-semibold text-[#c8102e] hover:gap-2 transition-all text-sm">Request quote <ArrowRight size={14} /></Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-[#f4f6fa]">
        <div className="container-fes grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="rounded-lg overflow-hidden">
            <img src="https://images.pexels.com/photos/8942043/pexels-photo-8942043.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1000" alt="Medics ready" className="w-full h-full object-cover" />
          </div>
          <div>
            <span className="section-label">Why FesMed EMS</span>
            <h2 className="font-head text-3xl md:text-4xl uppercase text-[#141414] mt-2 mb-5">Your Event, In Safe Hands</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">From festivals to motorsports, our experienced medics deliver advanced care on-site — fast, discreet and effective — so you can focus on the show.</p>
            <div className="space-y-4">
              {OFFERINGS.map((o) => (
                <div key={o.text} className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-white flex items-center justify-center text-[#c8102e] shrink-0"><o.icon size={18} /></div>
                  <p className="text-[#141414] font-medium pt-1.5">{o.text}</p>
                </div>
              ))}
            </div>
            <Link to="/contact" className="btn-crimson mt-8">Send Us An Enquiry <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
